const CONSTANTS = {
    MAXIMUM_NUMBER_OF_CHARACTERS: 100,
};
export default CONSTANTS;
